module.exports = __webpack_public_path__ + "static/img/icons-close-white.2fc87afc.svg";